<div id="devicedetailCard" class="control-card-white">
  <div class="control-card-header">
    <ng-container i18n="@@moveBollardDialog_title">Posizionamento dissuasore</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div id="content">

    <p class="text" i18n="@@moveBollardDialog_topText">Inserisci l'indirizzo in cui vorresti posizionare il dissuasore
    </p>

    <input id="input" type="text" [(ngModel)]="newAddress" />

    <p class="text" i18n="@@moveBollardDialog_bottomText">Dopo aver confermato l'indirizzo la mappa mostrerà il luogo
      selezionato e sarà possibile selezionare la posizione esatta cliccando col mouse</p>

    <div class="control-card-buttons">

      <a (click)="savenewAddress()" class="button" id="confirmButton">
        <ng-container i18n="@@moveBollardDialog_confirm">Conferma</ng-container>
        <span>
          <fa-icon icon="save"></fa-icon>
        </span>
      </a>
      <a (click)="closeDialog()" class="button button-red" id="cancelButton">
        <ng-container i18n="@@moveBollardDialog_cancel">Annulla</ng-container>
        <span>
          <fa-icon icon="times"></fa-icon>
        </span>
      </a>
    </div>
  </div>

</div>
